<template>
  <div v-loading="loading" class="alarmClass">
    <div :style="contentStyle">
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="自理情况" prop="selfCareCondition">
              <el-select  :disabled="model==='view'" v-model="form.selfCareCondition" placeholder="请选择自理情况" style="width: 100%">
                <el-option
                  v-for="item in selfCareConditionList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="视力" prop="sight">
              <el-select  :disabled="model==='view'" v-model="form.sight" placeholder="请选择视力" style="width: 100%">
                <el-option
                  v-for="item in sightTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">


          <el-col :span="12">
            <el-form-item label="听力" prop="hearing">
              <el-select  :disabled="model==='view'" v-model="form.hearing" placeholder="请选择听力" style="width: 100%">
                <el-option
                  v-for="item in hearingTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主治医生" prop="attendingPhysician">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.attendingPhysician"
                placeholder="请输入主治医生"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医院电话" prop="tel">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.tel"
                placeholder="请输入医院电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过敏药物" prop="allergyMedicine">
              <el-input
                clearable
                :disabled="model==='view'" v-model="form.allergyMedicine"
                placeholder="请输入过敏药物"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="病史" prop="medicalHistory">
              <el-input
              type="textarea"
                clearable
                 :disabled="model==='view'" v-model="form.medicalHistory"
                placeholder="请输入病史"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="主要疾病" prop="majorDisease">
              <el-select  :disabled="model==='view'" v-model="form.majorDisease_" multiple placeholder="请选择主要疾病" style="width: 100%">
                <el-option
                  v-for="item in majorDiseaseTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
  <script>
  import { saveHealthInfo,getHealthPageDetail
} from '../api/serveItemManage';
import { getStore } from '@/util/store';
import { getDictionary } from '@/api/common.js';
export default {
  components: {},
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      form: {
        name: '',
      },
      contentStyle: '',
      formRules: {
        name: [{ required: true, message: '物料名称不能为空', trigger: 'blur' }],
        nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        selfCareCondition:  [{ required: true, message: '自理情况不能为空', trigger: 'change' }],
      },
      matetialList: [],
      selfCareConditionList: [],
      sightTypeList: [],
      hearingTypeList: [],
      majorDiseaseTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  watch: {},
  methods: {
    calcHeight() {
      let bodyHight = document.body.clientHeight;
      let contentHeight = bodyHight - 340;
      this.contentStyle =
        'max-height:' + contentHeight + 'px; overflow-y: scroll;overflow-x: hidden;';
    },

    async initData() {
      if(getStore({name:'elderId'})){
        getHealthPageDetail({elderlyId: getStore({name:'elderId'})}).then((res)=>{
          this.form = res.data;
          this.form.majorDisease_ = this.form.majorDisease.split(',');
        });

      }
      getDictionary('nursinghome_self_care_type').then((res) => {
        this.selfCareConditionList = res.data;
      });
      getDictionary('nursinghome_sight_type').then((res) => {
        this.sightTypeList = res.data;
      });
      getDictionary('nursinghome_hearing_type').then((res) => {
        this.hearingTypeList = res.data;
      });
      getDictionary('nursinghome_major_disease_type').then((res) => {
        this.majorDiseaseTypeList = res.data;
      });

      if (this.model == 'add') {
      } else {
      }
    },
    saveRecord(cb) {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
        if(result){
          if(this.form.majorDisease_&&this.form.majorDisease_.length>0){

            this.form.majorDisease = this.form.majorDisease_.join(',');
          }
            saveHealthInfo({elderlyId:getStore({name:'elderId'}),...this.form}).then((res)=>{
              this.$message.success('操作成功！');
              this.$emit('success', this.form);
            if(cb)cb();
            });
          // saveHealthInfo(this.form).then((res)=>{
          //   this.$message.success('操作成功！',res);
          //   // setStore({
          //   //   name: 'elderId',
          //   //   content: res.data
          //   // })
          // });
        }
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
